import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function NcertBookPhyTopics() {



  return (
    <>

      <AllSubjectTopics  subject="physics" type="ncertbook" />

    </>
  );
}

export default NcertBookPhyTopics; 